class ProductGridItem {
    constructor(container) {
        this.container = container;
        this.variantSelect = this.container.querySelector('.variant-select');
        this.variantInput = this.container.querySelector('.product-variant-id');
        this.addToCartButton = this.container.querySelector('.add-to-cart');

        this.init();
    }

    init() {
        if (this.variantSelect) {
            this.variantSelect.addEventListener('change', this.handleVariantChange.bind(this));
        }
    }

    handleVariantChange(event) {
        const selectedOption = this.variantSelect.options[this.variantSelect.selectedIndex];
        const selectedVariantId = selectedOption.value;
        const isAvailable = selectedOption.getAttribute('data-available') === 'true';

        this.variantInput.value = selectedVariantId;

        if (isAvailable) {
            this.addToCartButton.disabled = false;
            this.addToCartButton.querySelector('span').innerText = 'ADD TO CART';
        } else {
            this.addToCartButton.disabled = true;
            this.addToCartButton.querySelector('span').innerText = 'SOLD OUT';
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const productItems = document.querySelectorAll('.product-grid-item');
    productItems.forEach(productItem => {
        new ProductGridItem(productItem);
    });
});
